export class Shader {

}